import { T } from '../../../common/locale/translate';

export function preparePlaceName(subject) {
  let names = [subject.country_name, subject.region_name, subject.city],
    cleanArray = [];
  names.forEach(element => {
    if (element) {
      cleanArray.push(element);
    }
  });
  let cleanName = cleanArray.join(', ');
  return cleanName;
}

export function prepareBreadcrumbs(subject) {
  let names = [subject.country_name, subject.region_name, subject.city],
    cleanArray = [];
  names.forEach(element => {
    if (element) {
      cleanArray.push(element);
    }
  });
  return cleanArray;
}

export const offer_type_for_human = offer_symbol => {
  const offers = {
    S: T('hotel_only'),
    A: T('holiday'),
    C1: T('one_way_flight'),
    C2: T('two_ways_flight')
  };

  return offers[offer_symbol];
};



// WEBPACK FOOTER //
// ./app/javascript/common/offer_utils.js